import { render, staticRenderFns } from "./practiceTest.vue?vue&type=template&id=0d0581d7&scoped=true"
import script from "./practiceTest.vue?vue&type=script&lang=js"
export * from "./practiceTest.vue?vue&type=script&lang=js"
import style0 from "./practiceTest.vue?vue&type=style&index=0&id=0d0581d7&lang=scss"
import style1 from "./practiceTest.vue?vue&type=style&index=1&id=0d0581d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0581d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0581d7')) {
      api.createRecord('0d0581d7', component.options)
    } else {
      api.reload('0d0581d7', component.options)
    }
    module.hot.accept("./practiceTest.vue?vue&type=template&id=0d0581d7&scoped=true", function () {
      api.rerender('0d0581d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/realTest/practiceTest.vue"
export default component.exports